<div [class]="'calendar ' + classes" [style.width]="width + 'px'">
	<div class="calendar-navs">
		<ng-container *ngIf="showYear">
			<sp-calendar-year-nav [currentDate]="currentDate" (yearChange)="onNavChange($event)"></sp-calendar-year-nav>
			<mat-divider></mat-divider>
		</ng-container>

		<sp-calendar-month-nav [min]="min" [max]="max" [currentDate]="currentDate" (monthChange)="onNavChange($event)"></sp-calendar-month-nav>
		<mat-divider></mat-divider>
	</div>
	<div class="month-grid" [ngClass]="{ 'date-range': range || rangeWeeks }">
		<div class="days">
			<div class="day-names">
				<div *ngFor="let name of ['M', 'T', 'W', 'T', 'F']" class="day-name" [style.width]="width / 7 + 'px'" [style.height]="width / 7 + 'px'">
					{{ name }}
				</div>
			</div>
			<div class="divider" [style.width]="width + 'px'">
				<mat-divider></mat-divider>
			</div>
		</div>

		<div class="weeks">
			<div *ngFor="let week of weeks" class="week">
				<ng-container *ngFor="let day of week">
					<div
						*ngIf="!day.isWeekendDay"
						customToolTip
						[toolTipShowDelay]="0"
						[toolTipHideDelay]="0"
						[position]="'top'"
						[additionalOffsetY]="-55"
						[contentTemplate]="disabledDayTooltip"
						[showToolTip]="!!day.tooltipContent">
						<!--WEEKDAYS-->
						<div
							class="{{ day.cssClasses }}"
							[style.width]="width / 7 + 'px'"
							[style.height]="width / 7 + 'px'"
							(click)="onClickDay(day)"
							(mouseenter)="hoverDates(day.mDate)"
							(mouseleave)="disabledHovered()"
							[ngStyle]="{ 'background-color': !day.disabled && day.selected && day.today ? '#00B476' : 'none' }"
							[ngClass]="{
								rightBorder:
									(day.selected && selectedDates.length > 1 && isLastSelectedDay(day.mDate)) ||
									(hovered && isLastHoveredDay(day.mDate) && selectedDates.length == 1),
								hovered: hovered && !isSelected(day.mDate) && !isRangeHovered(day.mDate),
								rangeHovered: isRangeHovered(day.mDate) && !isSelected(day.mDate)
							}">
							<div class="date-text">{{ day.mDate.date() }}</div>
							<div class="pass-dot" *ngIf="day.isDot"></div>
						</div>
						<!--END WEEKDAYS-->

						<ng-template #disabledDayTooltip>
							<sp-tooltip [text]="day.tooltipContent.text" [link]="day.tooltipContent.link" [linkText]="day.tooltipContent.linkText">
								<div dataDetails [innerHTML]="day.tooltipContent.dataDetails"></div>
							</sp-tooltip>
						</ng-template>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
	<div class="time-picker" *ngIf="showTime">
		<mat-divider></mat-divider>
		<app-time-picker
			[currentDate]="selectedDates?.length ? selectedDates[0] : currentDate"
			[forseDate$]="forceUpdate$"
			[min]="min"
			(timeResult)="timePickerResult($event)"></app-time-picker>
	</div>
</div>
